export const AD_POSITIONS = [1, 3, 6, 9, 12, 15, 18, 21];
